import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { FiLogOut } from 'react-icons/fi';
import {
  Heading, Subtitle, Link,
  Button,
} from '../components';
import { useAppState } from '../hooks';

const LoginWrapper = styled(Flex)`
  overflow: hidden;
`;

const LINK_TO_DOCS = 'https://developers.liveperson.com/maven-overview.html';

function Login() {
  const { logout } = useAppState();
  return (
    <LoginWrapper justifyContent="center" alignItems="center" flex={1}>
      <Flex flexDirection="column" alignItems="center">
        <Heading>Administrator access required</Heading>
        <Subtitle mb={4}>
          Only Conversation Cloud Administrators have access to Conversation Orchestrator.
          Please login with an Administrator account to continue.
        </Subtitle>
        <Link href={LINK_TO_DOCS} target="_blank" rel="noopener noreferrer">Learn more about Conversation Orchestrator</Link>
        <Button variant="secondary" onClick={logout || undefined} mt={4}>
          <Box mr={2}>Logout</Box>
          <FiLogOut />
        </Button>
      </Flex>
    </LoginWrapper>
  );
}

export default Login;
